<ng-container>
	<div id="shotdialog_div">
		<mat-card-header>
			<div
				fxLayout="row"
				fxLayoutAlign="space-between"
				style="margin-bottom: 10px; margin-top: 10px; width: 100%"
			></div>
		</mat-card-header>
		<mat-dialog-content
			ngClass.xs="mat-dialog-content_xs"
			ngClass.lt-md="mat-dialog-content_xs"
		>
			<div
				fxLayout="row"
				style="margin-bottom: 10px; align-items: center"
			>
				<div fxFlex="10%" class="text-right-p-20">日付</div>
				<div fxFlex="40%" style="padding-right: 10px">
					<input
						type="text"
						class="input-avg"
						[(ngModel)]="formData.name"
						(change)="handleInputChange($event, 'name')"
					/>
				</div>
				<div fxFlex="10%" class="text-right-p-20">クラブ</div>
				<div fxFlex="40%">
					<label>{{ this.getClubName() }}</label>
				</div>
			</div>
			<div fxLayout="row" style="margin-bottom: 10px">
				<div fxFlex="10%" class="text-right-p-20">メモ</div>
				<div fxFlex="90%">
					<textarea
						class="input-avg"
						style="height: 100px"
						[(ngModel)]="formData.memo"
						(change)="handleInputChange($event, 'memo')"
					></textarea>
				</div>
			</div>
			<div fxLayout="row">
				<table class="tbl-confirm-avg-shot">
					<thead>
						<tr>
							<th></th>
							<th>AD</th>
							<th>HB</th>
							<th>TP</th>
							<th>HD</th>
							<th>IM</th>
							<th>HF</th>
							<th>FN</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let pInfo of parts">
							<td style="text-align: left">{{ pInfo.part }}</td>
							<td
								*ngFor="
									let phase of [
										'address',
										'backswing',
										'top',
										'halfdown',
										'impact',
										'follow',
										'finish'
									]
								"
							>
								{{
									_.round(
										_.get(shot, [
											"sm",
											pInfo.field,
											phase,
											"metrics"
										]),
										1
									)
								}}
								{{ _.get(shot, ["sm", pInfo.field, phase, "unit"]) }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</mat-dialog-content>
		<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between">
			<div fxLayout="row" style="width: 100%; justify-content: center">
				<button
					class="memo_btn have"
					mat-raised-button
					style="background-color: #99774a"
					(click)="onCreateAVGShot()"
				>
					<span style="padding-left: 8px" translate>登録する</span>
				</button>
				<button
					(click)="cancel()"
					いいえ
					mat-raised-button
					class="close_btn"
					mat-dialog-close=""
					mat-raised-button
				>
					<span translate>キャンセル</span>
				</button>
			</div>
		</mat-dialog-actions>
	</div>
</ng-container>
